import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { AppTheme } from "../../../theme";
import { PlanTableFormat } from "../../../types/planning/plan.type";
import { RouteTrapWithStatus } from "./DeleteRouteAndTrapAssignmentConfirmDialog";

interface MergeRoutesTrapsErrorDialogProps {
  open: boolean;
  onClose: () => void;
  errorGroups: { message: string; plans: PlanTableFormat[] }[];
}

const MergeRoutesTrapsErrorDialog = ({
  open,
  onClose,
  errorGroups,
}: MergeRoutesTrapsErrorDialogProps) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle sx={{ fontWeight: "600", padding: "20px 0px 10px 20px" }}>
      Merge Requirements
    </DialogTitle>
    <Box position="absolute" top={4} right={4}>
      <IconButton onClick={onClose}>
        <Close />
      </IconButton>
    </Box>
    <DialogContent sx={{ padding: "10px 20px", whiteSpace: "pre-wrap" }}>
      {errorGroups.map((group) => (
        <Box key={group.message} mb={2}>
          <Box fontWeight="bold" mb={1}>
            {group.message}
          </Box>
          {group.plans.map((plan) => (
            <RouteTrapWithStatus key={plan.id} plan={plan} />
          ))}
        </Box>
      ))}
    </DialogContent>
    <DialogActions sx={{ margin: "10px 20px 20px 20px" }}>
      <Button
        onClick={onClose}
        sx={{ backgroundColor: AppTheme.palette.primary.main }}
        variant="contained"
      >
        Ok
      </Button>
    </DialogActions>
  </Dialog>
);

export default MergeRoutesTrapsErrorDialog;
